import LockIcon from "@mui/icons-material/Lock";
import CheckIcon from "@mui/icons-material/Check";
import { themeOptions as theme } from "../../../../../../app";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import * as React from "react";
import { Box, Button, Checkbox, FormControlLabel, Tooltip } from "@mui/material";
import { FINAL_VERIFICATION_ACTIONS } from "./final_verification_actions";
import { AlertColors } from "../../../../../../components/alerting/alert_enums";

export const get_status_for_action = (state_value) => {
  switch (state_value) {
    case 0:
      return null;
    case 1:
      return "Pending installer action";
    case 2:
      return "Pending start device control";
    case 4:
      return "24h control phase";
    case 8:
      return "Pending technical approval";
    case 16:
      return "Pending contract approval";
    case 20:
      return "Pending network operator metering data";
    case 22:
      return "Pending network operator metering validation";
    case 32:
      return "Pending procedure completion";
    case 64:
      return "Completed";
    default:
      return null;
  }
};

export const renderApprovalButtons = (step, mutation, isDisabled, hasMetering, includeMetering, setIncludeMetering) => {
  const actionMap = {
    8:
      hasMetering && includeMetering
        ? FINAL_VERIFICATION_ACTIONS.TECHNICAL_AND_METERING_APPROVAL
        : FINAL_VERIFICATION_ACTIONS.TECHNICAL_APPROVAL,
    16: FINAL_VERIFICATION_ACTIONS.CONTRACT_APPROVAL,
    20: FINAL_VERIFICATION_ACTIONS.NETWORK_METERING_AVAILABLE,
    22: FINAL_VERIFICATION_ACTIONS.NETWORK_METERING_APPROVAL,
  };

  const labelMap = {
    8: "Technical approval",
    16: "Contract approval",
    20: "Metering data available",
    22: "Metering data approval",
  };

  if (!actionMap[step.required_action]) {
    return null;
  } else {
    return (
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Button
          variant="outlined"
          color="inherit"
          size="small"
          disabled={isDisabled}
          onClick={() =>
            mutation({
              item_id: step.step_id,
              item_value: true,
              action: actionMap[step.required_action],
            })
          }
          sx={{ borderRadius: 2 }}
          disableElevation
        >
          {labelMap[step.required_action]}
        </Button>

        {
          // For Technical approval optionally show checkbox
          hasMetering && step.required_action == 8 && (
            <FormControlLabel
              sx={{ marginLeft: 2 }}
              control={
                <Checkbox
                  checked={includeMetering}
                  onChange={(e) => setIncludeMetering(e.target.checked)}
                  size="small"
                />
              }
              label="Network metering valid"
            />
          )
        }
      </Box>
    );
  }
};

export const renderCommissioningStatusIcons = (state_value, renderSmallIcon = false) => {
  let renderFontSize = renderSmallIcon ? "16px" : "24px";
  switch (state_value) {
    case 0:
      return renderIconWithTooltip(
        "Complete other phases first",
        <LockIcon sx={{ opacity: 0.5, fontSize: renderFontSize }} />,
      );
    case 1:
      return renderIconWithTooltip(
        get_status_for_action(state_value),
        <AssignmentIcon sx={{ opacity: 0.5, fontSize: renderFontSize }} />,
      );
    case 2:
      return renderIconWithTooltip(
        get_status_for_action(state_value),
        <PendingActionsIcon sx={{ opacity: 0.5, fontSize: renderFontSize }} />,
      );
    case 4:
      return renderIconWithTooltip(
        get_status_for_action(state_value),
        <AccessTimeFilledIcon sx={{ opacity: 0.5, fontSize: renderFontSize }} />,
      );
    case 8:
      return renderIconWithTooltip(
        get_status_for_action(state_value),
        <AdminPanelSettingsIcon sx={{ opacity: 0.5, fontSize: renderFontSize }} />,
      );
    case 16:
      return renderIconWithTooltip(
        get_status_for_action(state_value),
        <FactCheckIcon sx={{ opacity: 0.5, fontSize: renderFontSize }} />,
      );
    case 20:
      return renderIconWithTooltip(
        get_status_for_action(state_value),
        <HourglassBottomIcon sx={{ opacity: 0.5, fontSize: renderFontSize }} />,
      );
    case 22:
      return renderIconWithTooltip(
        get_status_for_action(state_value),
        <AdminPanelSettingsIcon sx={{ opacity: 0.5, fontSize: renderFontSize }} />,
      );
    case 32:
      return renderIconWithTooltip(
        get_status_for_action(state_value),
        <CheckIcon sx={{ opacity: 0.5, color: AlertColors.SUCCESS, fontSize: renderFontSize }} />,
      );
    case 64:
      return renderIconWithTooltip(
        get_status_for_action(state_value),
        <DoneAllIcon sx={{ opacity: 0.8, color: AlertColors.SUCCESS, fontSize: renderFontSize }} />,
      );
    default:
      return null;
  }
};

export function isCompleted(value) {
  return value === 64;
}

// Related device steps are locked when final verification is either
// 64: Completed, 8: Pending admin approval, 4: Pending device control,
// Check renderCommissioningStatusIcons for the value mapping or RequiredAction Flag class in the backend
export function isLockedByVerification(value) {
  return value >= 4;
}

//check renderCommissioningStatusIcons for the value mapping or RequiredAction Flag class in the backend
export function isPendingDeviceControl(value) {
  return value === 4;
}

//check renderCommissioningStatusIcons for the value mapping or RequiredAction Flag class in the backend
export function isPendingDeviceControlStart(value) {
  return value === 2;
}

const renderIconWithTooltip = (message, IconComponent) => (
  <Tooltip title={message}>
    <span>{IconComponent}</span>
  </Tooltip>
);
